import React, { useEffect, useState, useCallback, useRef } from 'react';
import Container from '../../../Container/Container';
import { useNavigate, useLocation, useParams } from 'react-router';
import { useForm, Controller } from "react-hook-form";
import { get, post, postFormData } from '../../../ApiServices/ApiServices';
import Select from 'react-select';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { FaCalendarAlt } from "react-icons/fa";
import { useDispatch, useSelector } from 'react-redux';
import { updateAddress } from '../../../redux/profileSlice';
import { zonedTimeToUtc, utcToZonedTime, format } from 'date-fns-tz';
import { GOOGLE_MAPS_API_KEY } from '../../../ApiServices/ApiServices';
function AddGroomDetail({ onNext, ticket, initialValues }) {
    const { register, handleSubmit, setValue, control: mainControl, reset, watch, formState: { errors } } = useForm({
        defaultValues: initialValues || {}
    });

    const { register: registerShipping, handleSubmit: handleSubmitShipping, control, formState: { errors: shippingErrors }, reset: resetShipping, setValue: setShippingValue } = useForm({
        defaultValues: {
            name: initialValues?.dropShipping?.name || "",
            addressLine1: initialValues?.dropShipping?.addressLine1 || "",
            addressLine2: initialValues?.dropShipping?.addressLine2 || "",
            city: initialValues?.dropShipping?.city || "",
            phone: initialValues?.dropShipping?.phone || "",
            state: initialValues?.dropShipping?.state || "",
            zipCode: initialValues?.dropShipping?.zipCode || "",
        }
    });

    const [dropShippingData, setDropShippingData] = useState(initialValues?.dropShipping || null);

    // Google Maps Autocomplete States
    const [isGoogleMapsLoaded, setIsGoogleMapsLoaded] = useState(false);
    const [mainAutocomplete, setMainAutocomplete] = useState(null);
    const [shippingAutocomplete, setShippingAutocomplete] = useState(null);

    // US States mapping
    const US_STATES_MAP = {
        'AL': 'Alabama', 'AK': 'Alaska', 'AZ': 'Arizona', 'AR': 'Arkansas',
        'CA': 'California', 'CO': 'Colorado', 'CT': 'Connecticut', 'DE': 'Delaware',
        'FL': 'Florida', 'GA': 'Georgia', 'HI': 'Hawaii', 'ID': 'Idaho',
        'IL': 'Illinois', 'IN': 'Indiana', 'IA': 'Iowa', 'KS': 'Kansas',
        'KY': 'Kentucky', 'LA': 'Louisiana', 'ME': 'Maine', 'MD': 'Maryland',
        'MA': 'Massachusetts', 'MI': 'Michigan', 'MN': 'Minnesota', 'MS': 'Mississippi',
        'MO': 'Missouri', 'MT': 'Montana', 'NE': 'Nebraska', 'NV': 'Nevada',
        'NH': 'New Hampshire', 'NJ': 'New Jersey', 'NM': 'New Mexico', 'NY': 'New York',
        'NC': 'North Carolina', 'ND': 'North Dakota', 'OH': 'Ohio', 'OK': 'Oklahoma',
        'OR': 'Oregon', 'PA': 'Pennsylvania', 'RI': 'Rhode Island', 'SC': 'South Carolina',
        'SD': 'South Dakota', 'TN': 'Tennessee', 'TX': 'Texas', 'UT': 'Utah',
        'VT': 'Vermont', 'VA': 'Virginia', 'WA': 'Washington', 'WV': 'West Virginia',
        'WI': 'Wisconsin', 'WY': 'Wyoming', 'DC': 'District of Columbia'
    };

    useEffect(() => {
        setDropShippingData(initialValues?.dropShipping || null)
    }, [initialValues?.dropShipping])

    const location = useLocation()
    const ID = location.state?.ID;
    const { eventId } = location.state || {}; // ✅ Get eventId from URL

    useEffect(() => {
        if (initialValues?.dropShipping) {
            resetShipping({
                name: initialValues?.dropShipping?.name || "",
                addressLine1: initialValues?.dropShipping?.addressLine1 || "",
                addressLine2: initialValues?.dropShipping?.addressLine2 || "",
                city: initialValues?.dropShipping?.city || "",
                phone: initialValues?.dropShipping?.phone || "",
                state: initialValues?.dropShipping?.state || "",
                zipCode: initialValues?.dropShipping?.zipCode || "",
            });
        }
    }, [initialValues, resetShipping]);

    const [isDropShipping, setIsDropShipping] = useState(initialValues?.dropShippingswitch || false);

    useEffect(() => {
        if (initialValues?.dropShippingswitch !== undefined) {
            setIsDropShipping(initialValues.dropShippingswitch);
            if (initialValues?.dropShippingswitch == true) {
                setIsDropShipping(true)
            }
        }
    }, [initialValues?.dropShippingswitch]);

    const [Customers, setCustomers] = useState([])
    const [isChecked, setIsChecked] = useState(false);
    const profile = useSelector((state) => state.profile.profile);
    const AlterAcc = watch("AlterAcc")
    const weddingDateWatch = watch("Weddingdate");
    const eventNameWatch = watch("event_name");
    const [eventWarning, setEventWarning] = useState(null);
    useEffect(() => {
        if (initialValues?.AlternatePickup !== undefined) {
            setIsChecked(initialValues.AlternatePickup);
        }
    }, [initialValues?.AlternatePickup]);

    const [order, setorder] = useState([])
    const [address, setaddress] = useState('')
    const [selectedAddress, setSelectedAddress] = useState('');
    const [openToDate, setOpenToDate] = useState(null);
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [getState, setGetState] = useState([]);
    const [selectedCompany, setError] = useState("");

    // Load Google Maps Script
    const loadGoogleMapsScript = () => {
        if (window.google && window.google.maps) {
            setIsGoogleMapsLoaded(true);
            return;
        }

        const script = document.createElement('script');
        script.src = `https://maps.googleapis.com/maps/api/js?key=${GOOGLE_MAPS_API_KEY}&libraries=places`;
        script.async = true;
        script.defer = true;
        script.onload = () => setIsGoogleMapsLoaded(true);
        document.head.appendChild(script);
    };

    // Initialize Google Maps on mount
    useEffect(() => {
        loadGoogleMapsScript();
    }, []);

    // Initialize main form autocomplete
    useEffect(() => {
        if (isGoogleMapsLoaded && window.google) {
            const timer = setTimeout(() => {
                initializeMainAutocomplete();
            }, 100);
            return () => clearTimeout(timer);
        }
    }, [isGoogleMapsLoaded]);

    // Initialize shipping autocomplete when modal is opened
    useEffect(() => {
        if (isGoogleMapsLoaded && window.google) {
            const modalElement = document.getElementById('dropShipping');
            if (modalElement) {
                const handleModalShown = () => {
                    setTimeout(() => {
                        initializeShippingAutocomplete();
                    }, 200);
                };

                modalElement.addEventListener('shown.bs.modal', handleModalShown);
                return () => modalElement.removeEventListener('shown.bs.modal', handleModalShown);
            }
        }
    }, [isGoogleMapsLoaded]);

    // Initialize Main Form Autocomplete
    const initializeMainAutocomplete = () => {
        if (!window.google || !window.google.maps) return;

        const addressInput = document.getElementById('main-address-input');
        if (!addressInput) return;

        const newAutocomplete = new window.google.maps.places.Autocomplete(
            addressInput,
            {
                types: ['address'],
                componentRestrictions: { country: 'us' }
            }
        );

        newAutocomplete.addListener('place_changed', () => handleMainPlaceSelect(newAutocomplete));
        setMainAutocomplete(newAutocomplete);
    };

    // Initialize Shipping Form Autocomplete
    const initializeShippingAutocomplete = () => {
        if (!window.google || !window.google.maps) return;

        const shippingInput = document.getElementById('shipping-address-input');
        if (!shippingInput) return;

        const newAutocomplete = new window.google.maps.places.Autocomplete(
            shippingInput,
            {
                types: ['address'],
                componentRestrictions: { country: 'us' }
            }
        );

        newAutocomplete.addListener('place_changed', () => handleShippingPlaceSelect(newAutocomplete));
        setShippingAutocomplete(newAutocomplete);
    };

    // Handle Main Form Place Selection
    const handleMainPlaceSelect = (autocompleteInstance) => {
        const place = autocompleteInstance.getPlace();

        if (!place.geometry) {
            console.error('No details available for this address');
            return;
        }

        let streetNumber = '';
        let route = '';
        let city = '';
        let stateCode = '';
        let stateName = '';
        let zipCode = '';

        place.address_components.forEach(component => {
            const types = component.types;

            if (types.includes('street_number')) {
                streetNumber = component.long_name;
            } else if (types.includes('route')) {
                route = component.long_name;
            } else if (types.includes('locality')) {
                city = component.long_name;
            } else if (types.includes('administrative_area_level_1')) {
                stateCode = component.short_name;
                stateName = component.long_name;
            } else if (types.includes('postal_code')) {
                zipCode = component.long_name;
            }
        });

        const fullAddress = streetNumber && route ? `${streetNumber} ${route}` : place.name;
        const fullStateName = US_STATES_MAP[stateCode] || stateName;

        // Update form values
        setValue('Address', fullAddress);
        setValue('City', city);
        setValue('State', fullStateName);
        setValue('ZipCode', zipCode);
    };

    // Handle Shipping Form Place Selection
    const handleShippingPlaceSelect = (autocompleteInstance) => {
        const place = autocompleteInstance.getPlace();

        if (!place.geometry) {
            console.error('No details available for this address');
            return;
        }

        let streetNumber = '';
        let route = '';
        let city = '';
        let stateCode = '';
        let stateName = '';
        let zipCode = '';

        place.address_components.forEach(component => {
            const types = component.types;

            if (types.includes('street_number')) {
                streetNumber = component.long_name;
            } else if (types.includes('route')) {
                route = component.long_name;
            } else if (types.includes('locality')) {
                city = component.long_name;
            } else if (types.includes('administrative_area_level_1')) {
                stateCode = component.short_name;
                stateName = component.long_name;
            } else if (types.includes('postal_code')) {
                zipCode = component.long_name;
            }
        });

        const fullAddress = streetNumber && route ? `${streetNumber} ${route}` : place.name;
        const fullStateName = US_STATES_MAP[stateCode] || stateName;

        // Update shipping form values
        setShippingValue('addressLine1', fullAddress);
        setShippingValue('city', city);
        setShippingValue('state', fullStateName);
        setShippingValue('zipCode', zipCode);
    };

    const GetCustomers = async () => {
        try {
            const api = `all-customers?size=1000`;
            const totalData = await get(api);

            if (totalData?.status === true) {
                setCustomers(totalData?.data?.rows || []);
            }
        } catch (err) {
            console.error('Error:', err.message);
            if (err?.message == "Invalid or expired token" || err?.message == "Invalid Token") {
                localStorage.removeItem('token');
                navigate('/login');
            }
        }
    };

    useEffect(() => {
        GetCustomers()
    }, [])

    useEffect(() => {
        if (selectedAddress) {
            const formattedAddress = selectedAddress.split("- Account:")[0];
            dispatch(updateAddress(formattedAddress));
        }
    }, [selectedAddress])

    useEffect(() => {
        ViewState();
        reset(initialValues || {});
        if (initialValues?.dropShipping?.enabled) {
            setIsDropShipping(true);
            setDropShippingData(initialValues.dropShipping);
            resetShipping(initialValues.dropShipping);
        }
    }, [initialValues, reset, resetShipping]);

    useEffect(() => {
        if (order.length > 0 && isChecked && initialValues?.Affiliated_store) {
            const affiliatedStoreName = initialValues.Affiliated_store;
            const selectedCompanyData = order.find(data => data.companyName === affiliatedStoreName);

            if (selectedCompanyData) {
                const companyId = selectedCompanyData.id;
                setValue("Affiliated_store", affiliatedStoreName);
                setValue('store_id', companyId);

                const fetchAffiliatedStoreData = async () => {
                    try {
                        const api = `all-group-customers/${companyId}`;
                        const response = await get(api);
                        if (response?.status === true) {
                            setaddress(response.data);
                        }
                    } catch (err) {
                        console.error('Error:', err);
                    }

                    const address = selectedCompanyData?.addresses?.[0];
                    if (address) {
                        setSelectedAddress(
                            `${address.billingAddress || ''}, ${address.billingAddressLine2 || ''}, ${address.billingCity || ''} 
                                 ${address.billingState || ''}, ${address.billingZip || ''} - Account: ${selectedCompanyData.account || 'N/A'}`
                        );
                    } else {
                        setSelectedAddress(`No Address Available - Account: ${selectedCompanyData.account || 'N/A'}`);
                    }
                };

                fetchAffiliatedStoreData();
            }
        }
    }, [order, isChecked, initialValues, setValue]);

    const onDropShippingSubmit = (data) => {
        setDropShippingData(data);
        setIsDropShipping(true);
        document.querySelector('[data-bs-dismiss="modal"]').click();
    };

    const onSubmit = (data) => {
        if (data.AlternatePickup && !data.Affiliated_store) {
            setError("Affiliated_store", {
                type: "manual",
                message: "Please select an affiliated store"
            });
            return;
        }

        const mergedData = {
            ...data,
            dropShipping: isDropShipping ? {
                enabled: true,
                ...dropShippingData
            } : {
                enabled: false,
                name: "",
                addressLine1: "",
                addressLine2: "",
                city: "",
                state: "",
                zipCode: "",
                phone: ""
            }
        };
        onNext(mergedData);
    };

    const ViewState = async () => {
        try {
            const api = `get-states`;
            const response = await get(api);
            if (response?.message === "success") {
                setGetState(response.data);
            }
        } catch (err) {
            console.error('Error:', err);
            if (err?.message == "Invalid or expired token" || err?.message == "Invalid Token") {
                localStorage.removeItem('token');
                navigate('/login');
            }
        }
    };

    const formatPhoneNumber = (input) => {
        const cleaned = input.replace(/\D/g, '');
        if (cleaned.length === 0) return '';
        if (cleaned.length <= 3) return `(${cleaned}`;
        if (cleaned.length <= 6) return `(${cleaned.slice(0, 3)}) ${cleaned.slice(3)}`;
        return `(${cleaned.slice(0, 3)}) ${cleaned.slice(3, 6)}-${cleaned.slice(6, 10)}`;
    };

    const handleChange = (e) => {
        const formatted = formatPhoneNumber(e.target.value);
        if (formatted.length <= 14) {
            e.target.value = formatted;
        }
    };

    const formatPhoneNumbermo = (input) => {
        const cleaned = input.replace(/\D/g, '');
        if (cleaned.length === 0) return '';
        if (cleaned.length <= 3) return `(${cleaned}`;
        if (cleaned.length <= 6) return `(${cleaned.slice(0, 3)}) ${cleaned.slice(3)}`;
        return `(${cleaned.slice(0, 3)}) ${cleaned.slice(3, 6)}-${cleaned.slice(6, 10)}`;
    };

    const handleChangemo = (e) => {
        const formatted = formatPhoneNumbermo(e.target.value);
        if (formatted.length <= 14) {
            e.target.value = formatted;
        }
    };

    const [selectedDate, setSelectedDate] = useState(null);
    const [minDate, setMinDate] = useState(null);
    const [blockedDates, setBlockedDates] = useState([]);

    useEffect(() => {
        const today = new Date();
        today.setHours(0, 0, 0, 0);
        const dayOfWeek = today.getDay();
        let blockedDatesArray = [];
        if (dayOfWeek >= 0 && dayOfWeek <= 3) {
            const daysUntilNextTuesday = dayOfWeek === 0 ? 9 : (9 - dayOfWeek);
            for (let i = 0; i <= daysUntilNextTuesday; i++) {
                const blockedDate = new Date(today);
                blockedDate.setDate(today.getDate() + i);
                blockedDatesArray.push(blockedDate.getTime());
            }
        } else if (dayOfWeek >= 4 && dayOfWeek <= 6) {
            const daysUntil2ndTuesday = 16 - dayOfWeek;
            for (let i = 0; i <= daysUntil2ndTuesday; i++) {
                const blockedDate = new Date(today);
                blockedDate.setDate(today.getDate() + i);
                blockedDatesArray.push(blockedDate.getTime());
            }
        }

        setBlockedDates(blockedDatesArray);
        setMinDate(today);
        let nextAvailableDate = new Date(today);
        while (blockedDatesArray.includes(nextAvailableDate.getTime())) {
            nextAvailableDate.setDate(nextAvailableDate.getDate() + 1);
        }
        setOpenToDate(nextAvailableDate);
    }, []);

    const handleDateChange = (date) => {
        if (!date) {
            setSelectedDate(null);
            setValue("Weddingdate", "", { shouldValidate: true });
            return;
        }

        const localDate = new Date(date.getFullYear(), date.getMonth(), date.getDate());
        const year = localDate.getFullYear();
        const month = String(localDate.getMonth() + 1).padStart(2, "0");
        const day = String(localDate.getDate()).padStart(2, "0");
        const formattedDate = `${year}-${month}-${day}`;

        setSelectedDate(localDate);
        setValue("Weddingdate", formattedDate, { shouldValidate: true });
    };

    const parseDate = (dateValue) => {
        if (!dateValue) return null;

        let dateString;

        if (typeof dateValue === 'string' && dateValue.includes('T')) {
            dateString = dateValue.split('T')[0];
        }
        else if (typeof dateValue === 'string') {
            dateString = dateValue;
        }
        else if (dateValue instanceof Date) {
            const year = dateValue.getFullYear();
            const month = String(dateValue.getMonth() + 1).padStart(2, "0");
            const day = String(dateValue.getDate()).padStart(2, "0");
            dateString = `${year}-${month}-${day}`;
        }
        else {
            return null;
        }

        const [year, month, day] = dateString.split('-').map(Number);
        return new Date(year, month - 1, day);
    };

    const isAllowedDate = useCallback(
        (date) => !blockedDates.includes(date.getTime()),
        [blockedDates]
    );

    useEffect(() => {
        if (initialValues?.dropShipping?.name) {
            setValue("name", initialValues.dropShipping.name);
        }
    }, [initialValues, setValue]);



    const GetVAlidtation = async (eventName, weddingDate, account) => {
        try {

            if (!eventName || !weddingDate || !account) {
                setEventWarning(null);
                return;
            }

            // const api = `getWeddingEventByNameAndWeddingDate?eventName=${eventName}&weddingDate=${weddingDate}&account=${account}&id=${eventId || ""}`;
            const api = `getWeddingEventByNameAndWeddingDate?eventName=${eventName}&weddingDate=${weddingDate}&account=${account}${eventId ? `&id=${eventId}` : ""}`;

            const response = await get(api);

            if (response?.status == true) {
                setEventWarning(
                    response?.message
                );

            } else {
                setEventWarning(null);
            }

        } catch (err) {
            console.error("Validation Error:", err);
            setEventWarning(null);

        }
    };


    const isAdmin = profile?.name === "Admin";

    const account = isAdmin ? AlterAcc : profile?.account;


    useEffect(() => {
        if (weddingDateWatch && eventNameWatch && account) {
            GetVAlidtation(eventNameWatch, weddingDateWatch, account);
        }
    }, [weddingDateWatch, eventNameWatch, account]);


    // console.log(profile?.account)
    // console.log(profile, "profile-------------------")

    return (
        <Container>
            <div className="nk-content">
                <div className="container-fluid">
                    <div className="nk-content-inner">
                        <div className="nk-content-body">
                            <div className="nk-block-head nk-block-head-sm">
                                <div className="nk-block-between">
                                    <div className="nk-block-head-content">
                                        <h3 className="nk-block-title page-title">{location.pathname == "/add-wedding-order" ? "Add" : "Update"} Weddings Event {(ticket && location.pathname != "/add-order") && `#${ticket}`}</h3>
                                    </div>
                                </div>
                            </div>

                            <div className="card card-full">
                                <div className="card-inner">
                                    <div className="stepperLeft">
                                        <div className="row">
                                            <div className="col-md-4 brIght">
                                                <section className="section1">
                                                    <header>
                                                        <div className="bead current"><span>1</span></div> {location.pathname == "/add-wedding-order" ? "Add" : "Update"}   Groom's Detail
                                                    </header>
                                                </section>
                                                <section className="section2">
                                                    <header>
                                                        <div className="bead"><span>2</span></div>{location.pathname == "/add-wedding-order" ? "Add" : "Update"}  Fiancée's Detail
                                                    </header>
                                                </section>
                                                {
                                                    location.pathname == "/add-wedding-order" &&
                                                    <section className="section2">
                                                        <header>
                                                            <div className="bead"><span>3</span></div> {location.pathname == "/add-wedding-order" ? "Add" : "Update"} Groom's  Style Detail
                                                        </header>
                                                    </section>
                                                }

                                                {
                                                    location.pathname == "/add-wedding-order" &&
                                                    <section className="section2">
                                                        <header>
                                                            <div className="bead"><span>4</span></div> {location.pathname == "/add-wedding-order" ? "Add" : "Update"} Groomsmen Style Detail
                                                        </header>
                                                    </section>
                                                }

                                                <section>
                                                    <header>
                                                        <div className="bead"><span>{location.pathname == "/update-wedding-order" ? 3 : 5}</span></div> {location.pathname == "/add-wedding-order" ? "Add" : "Update"} Notes
                                                    </header>
                                                </section>
                                            </div>

                                            <div className="col-md-8">
                                                <h4>{location.pathname == "/add-wedding-order" ? "Add" : "Update"}  Groom's Detail--------------</h4>
                                                <form onSubmit={handleSubmit(onSubmit)}>
                                                    <div className="inputCardBox mt-4">
                                                        <div className="row">
                                                            <div className="col-md-6 mb-3">
                                                                <label>
                                                                    Wedding Date <span className="text-red-500">*</span>
                                                                </label>
                                                                <div className="date-picker-container">
                                                                    <Controller
                                                                        name="Weddingdate"
                                                                        control={mainControl}
                                                                        defaultValue={initialValues?.Weddingdate || null}
                                                                        rules={{ required: "Event date is required" }}
                                                                        render={({ field }) => {
                                                                            const selectedValue = parseDate(field.value);
                                                                            const openToValue = parseDate(field.value) || selectedDate || openToDate;

                                                                            return (
                                                                                <DatePicker
                                                                                    selected={selectedValue}
                                                                                    onChange={(date) => {
                                                                                        if (!date) {
                                                                                            field.onChange(null);
                                                                                            handleDateChange(null);
                                                                                            return;
                                                                                        }

                                                                                        const cleanDate = new Date(
                                                                                            date.getFullYear(),
                                                                                            date.getMonth(),
                                                                                            date.getDate()
                                                                                        );

                                                                                        field.onChange(cleanDate);
                                                                                        handleDateChange(cleanDate);
                                                                                    }}
                                                                                    minDate={minDate}
                                                                                    openToDate={openToValue}
                                                                                    dateFormat="MM/dd/yyyy"
                                                                                    placeholderText="MM/DD/YYYY"
                                                                                    className="form-control"
                                                                                    wrapperClassName="w-100"
                                                                                    required
                                                                                    filterDate={isAllowedDate}
                                                                                    utcOffset={0}
                                                                                    timeZone="UTC"
                                                                                    fixedHeight={true}
                                                                                    shouldCloseOnSelect={true}
                                                                                    showPopperArrow={false}
                                                                                />
                                                                            );
                                                                        }}
                                                                    />
                                                                    <FaCalendarAlt className="calendar-icon" />
                                                                </div>

                                                                {errors.Weddingdate && (
                                                                    <p className="text-red-500">{errors.Weddingdate.message}</p>
                                                                )}
                                                            </div>
                                                            <div className="col-6 col-md-6 mb-3">
                                                                <label>
                                                                    Occasion (Groom's Last Name)<span className="text-red-500">*</span>
                                                                </label>
                                                                <input
                                                                    type="text"
                                                                    placeholder="Enter event name"
                                                                    {...register("event_name", {
                                                                        required: "Occasion is required",
                                                                        pattern: {
                                                                            value: /^[A-Za-z0-9 ]+$/,
                                                                            message: "Only letters and numbers are allowed"
                                                                        }
                                                                    })}
                                                                    onChange={(e) => {
                                                                        const cleaned = e.target.value.replace(/[^A-Za-z0-9 ]/g, "");
                                                                        e.target.value = cleaned;
                                                                        setValue("event_name", cleaned, { shouldValidate: true });
                                                                    }}
                                                                />

                                                                {errors.event_name && <p className='red'>{errors.event_name.message}</p>}
                                                            </div>
                                                        </div>
                                                        <div className="row">
                                                            <div className="col-6 col-md-6 mb-3">
                                                                <label>
                                                                    First Name <span className="text-red-500">*</span>
                                                                </label>
                                                                <input
                                                                    type="text"
                                                                    placeholder="Enter first name"
                                                                    {...register("Firstname", {
                                                                        required: "First name is required",
                                                                        pattern: {
                                                                            value: /^[A-Za-z0-9]+$/,
                                                                            message: "Only letters and numbers are allowed",
                                                                        },
                                                                    })}
                                                                />
                                                                {errors.Firstname && (
                                                                    <p className="red">{errors.Firstname.message}</p>
                                                                )}
                                                            </div>

                                                            <div className="col-6 col-md-6 mb-3">
                                                                <label>
                                                                    Last Name <span className="text-red-500">*</span>
                                                                </label>
                                                                <input
                                                                    type="text"
                                                                    placeholder="Enter last name"
                                                                    {...register("Lastname", {
                                                                        required: "Last name is required",
                                                                        pattern: {
                                                                            value: /^[A-Za-z0-9]+$/,
                                                                            message: "Only letters and numbers are allowed",
                                                                        },
                                                                    })}
                                                                />
                                                                {errors.Lastname && (
                                                                    <p className="red">{errors.Lastname.message}</p>
                                                                )}
                                                            </div>

                                                            <div className="col-md-6 mb-3">
                                                                <label>Address <span className="text-red-500"></span></label>
                                                                <input
                                                                    id="main-address-input"
                                                                    type="text"
                                                                    placeholder="Start typing address..."
                                                                    {...register("Address")}
                                                                />
                                                                {errors.Address && <p className='red'>{errors.Address.message}</p>}
                                                                <div className="text-xs text-gray-500 mt-1">
                                                                    Start typing to see address suggestions
                                                                </div>
                                                            </div>
                                                            <div className="col-md-6 mb-3 stateSelect">
                                                                <label>State <span className="text-red-500"></span></label>
                                                                <Controller
                                                                    name="State"
                                                                    control={mainControl}
                                                                    render={({ field, fieldState: { error } }) => (
                                                                        <div>
                                                                            <Select
                                                                                {...field}
                                                                                options={getState.map(item => ({
                                                                                    value: item.name,
                                                                                    label: item.name
                                                                                }))}
                                                                                placeholder="Select state"
                                                                                isClearable
                                                                                onChange={(selectedOption) => {
                                                                                    field.onChange(selectedOption ? selectedOption.value : '');
                                                                                }}
                                                                                value={getState.map(item => ({
                                                                                    value: item.name,
                                                                                    label: item.name
                                                                                })).find(option => option.value === field.value) || null}
                                                                                className={error ? 'is-invalid' : ''}
                                                                            />
                                                                            {error && <p className="red">{error.message}</p>}
                                                                        </div>
                                                                    )}
                                                                />
                                                            </div>

                                                            <div className="col-6 col-md-6 mb-3">
                                                                <label>City <span className="text-red-500"></span></label>
                                                                <input type="text" placeholder="Enter city" {...register("City")} />
                                                                {errors.City && <p className='red'>{errors.City.message}</p>}
                                                            </div>
                                                            <div className="col-6 col-md-6 mb-3">
                                                                <label>Zip Code <span className="text-red-500"></span></label>
                                                                <input
                                                                    type="text"
                                                                    placeholder="Enter zip code"
                                                                    {...register("ZipCode", {
                                                                        pattern: {
                                                                            value: /^\d{5}$/,
                                                                            message: "ZIP code must be exactly 5 digits"
                                                                        }
                                                                    })}

                                                                    onInput={(e) => {
                                                                        e.target.value = e.target.value.replace(/[^0-9]/g, '');
                                                                    }}
                                                                />
                                                                {errors.ZipCode && <p className='red'>{errors.ZipCode.message}</p>}
                                                            </div>
                                                            <div className="col-md-6 mb-3">
                                                                <label>Phone Number <span className="text-red-500"></span></label>
                                                                <input
                                                                    type="text"
                                                                    className={`w-full p-2 border rounded focus:outline-none focus:ring-2 focus:ring-blue-500 
${errors.PhoneNumber ? 'border-red-500' : 'border-gray-300'}`}
                                                                    placeholder="(XXX) XXX-XXXX"
                                                                    maxLength="14"
                                                                    defaultValue={initialValues?.PhoneNumber || ""}
                                                                    {...register('PhoneNumber', {
                                                                        onChange: handleChange,
                                                                        pattern: {
                                                                            value: /^\(\d{3}\) \d{3}-\d{4}$/,
                                                                            message: "Please enter a valid phone number"
                                                                        }
                                                                    })}
                                                                />
                                                                {errors.PhoneNumber && (
                                                                    <p className="text-red-500 text-sm">{errors.PhoneNumber.message}</p>
                                                                )}
                                                            </div>
                                                            <div className="col-md-6 mb-3">
                                                                <label>Email Address <span className="text-red-500"></span></label>
                                                                <input type="text" placeholder="Enter email" {...register("EmailAddress", {
                                                                    pattern: {
                                                                        value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                                                                        message: "Please enter a valid email address"
                                                                    }
                                                                })} />
                                                                {errors.EmailAddress && <p className='red'>{errors.EmailAddress.message}</p>}
                                                            </div>

                                                            {profile?.name == "Admin" && (
                                                                <div className="col-md-6 mb-3 stateSelect">
                                                                    <label>Account Number <span className="text-red-500">*</span></label>
                                                                    <Controller
                                                                        name="AlterAcc"
                                                                        control={mainControl}
                                                                        defaultValue={AlterAcc || ""}
                                                                        rules={{
                                                                            required: "Account number is required"
                                                                        }}
                                                                        render={({ field, fieldState: { error } }) => {
                                                                            const options = Customers.map(item => ({
                                                                                value: String(item.account),
                                                                                label: `${item.account} (${item.companyName})`
                                                                            }));

                                                                            const selectedOption = options.find(
                                                                                option => option.value === String(field.value)
                                                                            );

                                                                            return (
                                                                                <div>
                                                                                    <Select
                                                                                        options={options}
                                                                                        value={selectedOption || null}
                                                                                        onChange={(selected) => {
                                                                                            setSelectedAddress(null);
                                                                                            setValue("Affiliated_store", "");
                                                                                            if (!selected) {
                                                                                                field.onChange("");
                                                                                                setValue("AccountId", "");
                                                                                                return;
                                                                                            }

                                                                                            const selectedValue = selected.value;
                                                                                            const selectedCustomer = Customers.find(
                                                                                                c => String(c.account) === String(selectedValue)
                                                                                            );
                                                                                            const selectedId = selectedCustomer ? String(selectedCustomer.id) : "";

                                                                                            field.onChange(selectedValue);
                                                                                            setValue("AccountId", selectedId);
                                                                                        }}
                                                                                        placeholder="Select account"
                                                                                        isClearable
                                                                                        isDisabled={location.pathname == "/add-wedding-order" ? false : true}
                                                                                        menuPortalTarget={document.body}
                                                                                    />
                                                                                    {error && (
                                                                                        <div className='red'>
                                                                                            {error.message}
                                                                                        </div>
                                                                                    )}
                                                                                </div>
                                                                            );
                                                                        }}
                                                                    />
                                                                </div>
                                                            )}
                                                            {eventWarning && (
                                                                <div
                                                                    style={{
                                                                        backgroundColor:
                                                                            "#FF0000",
                                                                        color: "#FFFFFF",
                                                                        marginTop: "10px",
                                                                        fontSize: "14px",
                                                                        display:
                                                                            "inline-block",
                                                                    }}
                                                                >
                                                                    {eventWarning}
                                                                </div>
                                                            )}
                                                            <br></br>
                                                            <div className="col-md-12 mt-3">
                                                                <button type="submit"
                                                                    className="addBtnCustomer">Continue</button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </form>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="modal fade" tabIndex="-1" id="dropShipping">
                <div className="modal-dialog" role="document">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title">Drop Shipping</h5>
                            <a href="#" className="close" data-bs-dismiss="modal" aria-label="Close">
                                <em className="icon ni ni-cross-c"></em>
                            </a>
                        </div>
                        <form onSubmit={(e) => {
                            e.preventDefault();
                            handleSubmitShipping(onDropShippingSubmit)();
                        }}>
                            <div className="modal-body inputCardBox">
                                <div className="row">
                                    <div className="col-md-12 mb-2">
                                        <h6 className="instructionHeading">
                                            Drop shipment are charged all shipping costs, plus a $10 fee per address per week.
                                            RS labels are included inside each box unless otherwise requested.
                                        </h6>
                                    </div>
                                    <div className="col-md-12 mb-3">
                                        <label>Name  <span className="text-danger">*</span></label>
                                        <input
                                            type="text"
                                            className={`form-control ${shippingErrors.name ? 'is-invalid' : ''}`}
                                            placeholder="Enter Name"
                                            defaultValue={initialValues?.dropShipping?.name || ""}
                                            {...registerShipping("name", {
                                                required: "Name is required",
                                                value: initialValues?.dropShipping?.name || ""
                                            })}
                                        />
                                        {shippingErrors.name && <p className="red">{shippingErrors.name.message}</p>}
                                    </div>
                                    <div className="col-md-12 mb-3">
                                        <label>Address line 1<span className="text-danger">*</span> </label>
                                        <input
                                            id="shipping-address-input"
                                            type="text"
                                            className={`form-control ${shippingErrors.addressLine1 ? 'is-invalid' : ''}`}
                                            placeholder="Start typing address..."
                                            {...registerShipping("addressLine1", { required: "Address is required" })}
                                        />
                                        {shippingErrors.addressLine1 && <p className="red">{shippingErrors.addressLine1.message}</p>}
                                        <div className="text-xs text-gray-500 mt-1">
                                            Start typing to see address suggestions
                                        </div>
                                    </div>
                                    <div className="col-md-12 mb-3">
                                        <label>Address line 2</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            placeholder="Enter Address line 2"
                                            {...registerShipping("addressLine2")}
                                        />
                                    </div>
                                    <div className="col-md-6 mb-3">
                                        <label>City </label>
                                        <input
                                            type="text"
                                            className={`form-control ${shippingErrors.city ? 'is-invalid' : ''}`}
                                            placeholder="Enter City"
                                            {...registerShipping("city")}
                                        />
                                        {shippingErrors.city && <p className="red">{shippingErrors.city.message}</p>}
                                    </div>
                                    <div className="col-md-6 mb-3 stateSelect">
                                        <label>State </label>
                                        <Controller
                                            name="state"
                                            control={control}
                                            render={({ field, fieldState: { error } }) => (
                                                <div>
                                                    <Select
                                                        {...field}
                                                        options={getState.map(item => ({
                                                            value: item.name,
                                                            label: item.name
                                                        }))}
                                                        placeholder="Select state"
                                                        onChange={(selectedOption) => {
                                                            field.onChange(selectedOption ? selectedOption.value : '');
                                                        }}
                                                        value={getState.map(item => ({
                                                            value: item.name,
                                                            label: item.name
                                                        })).find(option => option.value === field.value) || null}
                                                        className={error ? 'is-invalid' : ''}
                                                    />
                                                    {error && <p className="red">{error.message}</p>}
                                                </div>
                                            )}
                                        />
                                    </div>
                                    <div className="col-md-6 mb-3">
                                        <label>Zip Code </label>
                                        <input
                                            type="text"
                                            className={`form-control ${shippingErrors.zipCode ? 'is-invalid' : ''}`}
                                            placeholder="Enter Zip Code"
                                            {...registerShipping("zipCode", {
                                                pattern: {
                                                    value: /^\d+$/,
                                                    message: "Please enter a valid zip code"
                                                }
                                            })}
                                            onInput={(e) => {
                                                e.target.value = e.target.value.replace(/[^0-9]/g, '');
                                            }}
                                        />
                                        {shippingErrors.zipCode && <p className="red">{shippingErrors.zipCode.message}</p>}
                                    </div>
                                    <div className="col-md-6 mb-3">
                                        <label>Phone <span className="text-danger">*</span> </label>
                                        <input
                                            type="text"
                                            className={`form-control ${shippingErrors.phone ? 'is-invalid' : ''}`}
                                            placeholder="(XXX) XXX-XXXX"
                                            maxLength="14"
                                            {...registerShipping('phone', {
                                                required: "Phone number is required",
                                                onChange: handleChangemo,
                                                pattern: {
                                                    value: /^\(\d{3}\) \d{3}-\d{4}$/,
                                                    message: "Please enter a valid phone number"
                                                }
                                            })}
                                        />
                                        {shippingErrors.phone && <p className="red">{shippingErrors.phone.message}</p>}
                                    </div>
                                </div>
                                <div className="row mt-3">
                                    <div className="col-md-4 mb-3">
                                        <button type="submit" className="addBtnCustomer">Add Ship</button>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </Container>
    )
}

export default AddGroomDetail